<template>
	<div class="file">
		<div class="file-preview">
			<q-icon size="24px" class="file-preview-icon" name="insert_drive_file" />
		</div>
		<div class="file-info">
			<span class="file-info-name" v-text="fileName" />
			<span class="file-info-size" v-text="humanSize" />
		</div>
		<div class="file-actions">
			<a :href="src" :download="fileName">
				<q-icon size="24px" name="get_app" color="primary" />
			</a>
		</div>
	</div>
</template>

<script>
export default {
	name: 'MessageFile',
	props: {
		src: {
			type: String
		},
		fileName: {
			type: String
		},
		humanSize: {
			type: String
		}
	}
};
</script>
<style lang="scss" scoped>
@import '@/styles';
a {
	text-decoration: none;
}
.file-preview-icon {
	color: #636363;
}
.file {
	padding: 10px 12px;
	background: #f7f7f7;
	border-radius: 4px;
	display: grid;
	width: 100%;
	grid-template-columns: auto 1fr auto;
	align-items: center;
	gap: 10px;
}
.file-info {
	display: flex;
	flex-direction: column;
	overflow: hidden;
	&-name {
		color: rgba(0, 0, 0, 0.6);
		font-weight: 400;
		font-size: 14px;
		line-height: 100%;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	&-size {
		margin-top: 3px;
		font-weight: 400;
		font-size: 12px;
		line-height: 100%;
		color: #a6a6a6;
	}
}
</style>
